import React from 'react';
import {  Modal } from 'react-bootstrap';

const RenameModal = ( { show, handleClose, handleRename, setRenameState } ) =>
{

	return (
		<Modal
			show={show}
			onHide={handleClose}
			backdrop="static"
			keyboard={false}
			dialogClassName="modal-dialog-centered m-auto">
			<Modal.Header className="flex-column">
				<Modal.Title className="modal-title" id="deleteModalLabel" style={{
					"marginTop" : "20px",
					"direction" : "rtl"
				}}>تغییر نام</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<input style={{
					"direction" : "rtl"
				}} className="rename-playlist-input" minLength="1" type="text" id="playlistName" name="playlistName" onChange={e => setRenameState( { "name" : e.target.value } )}/>
			</Modal.Body>
			<Modal.Footer className="justify-content-center">
				<button type="button" className="btn btn-modal" onClick={handleClose}>خیر</button>
				<button type="button" className="btn btn-modal" onClick={handleRename}>بله</button>
			</Modal.Footer>
		</Modal>
	);
};

export default RenameModal;
